<template>
  <div class="overflow-y-scroll">
    <section>
      <fieldset
        class="form-field"
        v-for="(tool, index) in editTools"
        :key="index"
      >
        <div class="form-inline flex-row">
          <legend>
            Tool #{{ index }}:
            <a
              href="javascript:void(0)"
              class="input-prepend-btn"
              @click="addTool(index)"
            >
              <i class="material-icons-outlined align-middle">add</i>
            </a>
            <a
              href="javascript:void(0)"
              class="input-apend-btn"
              @click="deleteTool(index)"
            >
              <i class="material-icons-outlined align-middle">delete</i>
            </a>
          </legend>
        </div>
        <div class="form-inline certi flex-row">
          <label>Name:</label>
          <div class="input-group">
            <model-select
              :options="suggestions"
              v-model="editTools[index].name"
            ></model-select>
          </div>
        </div>
      </fieldset>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          Edit Tools
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  props: ["propsData", "toolSuggestions"],
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  data() {
    return {
      focusedIndex: 0,
      editTools: null,
    };
  },
  components: {
    ModelSelect,
  },
  created: function () {
    this.initData();
  },
  methods: {
    addTool: function (index) {
      this.editTools.splice(index + 1, 0, {});
    },
    deleteTool: function (index) {
      this.editTools.splice(index, 1);
      if (this.editTools.length == 0) {
        this.editTools.push({});
      }
    },
    initData: function () {
      if (this.propsData) {
        const propsData = JSON.parse(JSON.stringify(this.propsData));
        if (propsData && propsData.length > 0) {
          this.editTools = propsData.map((item) => {
            if (typeof item === "string") {
              return {
                name: item,
              };
            } else if (typeof item === "object") {
              return {
                name: item.name,
                link: item.link,
              };
            }
            return {};
          });
        } else {
          this.editTools = [{}];
        }
      } else {
        this.editTools = [{}];
      }

      if (this.toolSuggestions) {
        this.suggestions = this.toolSuggestions.map((item) => ({
          text: item.name ? item.name : "",
          value: item.name ? item.name : "",
        }));
      }
    },
    onButtonClick: function () {
      const data = [];
      this.editTools.forEach((item) => {
        if (item.name) {
          const findItem = this.toolSuggestions.find(
            (sItem) => sItem.name === item.name
          );
          if (findItem) {
            data.push({
              name: findItem.name,
              link: findItem.link ? findItem.link : null,
            });
          } else {
            data.push({
              name: item.name,
            });
          }
        }
      });
      this.$emit("onButtonClick", data);
    },
    onFocus: function (index) {
      this.focusedIndex = index;
    },
    onSelected: function (item) {
      this.editTools[this.focusedIndex] = item.item;
    },
  },
};
</script>
